// extracted by mini-css-extract-plugin
export var accordion = "_ba-0";
export var chevron = "_ba-3";
export var closed = "_ba-2";
export var content = "_ba-4";
export var open = "_ba-1";
export var rotate = "_ba-5";